import { Grid, Typography } from "@material-ui/core";
import * as React from "react";
import { useDataProvider } from "react-admin";
import { Bar, BarChart, CartesianGrid, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";
import useAiInsight from "../../../Components/AiAssistant/useAiInsight";
import { buildAiBaseParams } from "../../../Components/AiAssistant/buildAiBaseParams";

const gridContainerProps: any = {
  container: true,
  direction: "row",
  item: true,
  xs: 12,
  spacing: 1,
  justify: "space-around",
  alignItems: "center",
};

const MonthlyServiceableRequestComponent = ({ filterParams }) => {
  const dataProvider = useDataProvider();
  const [data, setData] = React.useState([] as any);
  const resourceEndpoint = "/pbhrequestserviceables/cockpit/monthlyserviceablerequest";

  const calculateYAxisMax = () => {
    if (data.length === 0) return 10;

    const maxRequestCount = Math.max(...data.map(item => item.requestCount || 0));
    const maxWithPadding = maxRequestCount * 1.3;
    return Math.floor(maxWithPadding);
  };

  const insightParams = React.useMemo(() => {
    if (!data.length) return null;
    const totalRequests = data.reduce((s: number, item: any) => s + (item.requestCount ?? 0), 0);
    const monthlyData = data.map((item: any) => `${item.month}:${item.requestCount ?? 0}`).join(",");
    return {
      ...buildAiBaseParams(filterParams),
      totalRequests: totalRequests.toString(),
      periodCount: data.length.toString(),
      avgMonthlyRequests: (totalRequests / data.length).toFixed(0),
      monthlyData,
    };
  }, [filterParams, data]);
  useAiInsight("monthlyserviceablerequestcomponent", insightParams);

  React.useEffect(() => {
    GetMonthlyServiceableRequestData();
  }, [filterParams]);

  const GetMonthlyServiceableRequestData = async () => {
    await dataProvider
      .getList(resourceEndpoint, {
        pagination: { page: 1, perPage: 999999 },
        sort: { field: "id", order: "ASC" },
        filter: filterParams,
      })
      .then(({ data }) => {
        setData(data);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const renderCustomizedLabel = props => {
    const { x, y, width, height, value } = props;
    const radius = 17;

    return (
      <g>
        <circle cx={x + width / 2} cy={y - radius} r={radius} fill="#FF9C00" />
        <text x={x + width / 2} y={y - radius} fill="#fff" textAnchor="middle" dominantBaseline="middle">
          {value}
        </text>
      </g>
    );
  };

  return (
    <>
      <Typography gutterBottom variant="h5" component="h2" align="center">
        Monthly Pool Request
      </Typography>
      <Grid {...gridContainerProps} alignItems={"flex-start"}>
        <Grid item xs={12} sm={5}>
          <div style={{ width: 1000, height: 400 }}>
            <ResponsiveContainer>
              <BarChart
                width={500}
                height={300}
                data={data}
                margin={{
                  top: 5,
                  right: 30,
                  left: 20,
                  bottom: 5,
                }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="month" />
                <YAxis domain={[0, calculateYAxisMax()]} />
                <Tooltip />
                <Legend payload={[{ value: "Request Count", type: "line", id: "requestCount", color: "#FF9C00" }]} />
                <Bar dataKey="requestCount" fill="#FF9C00" minPointSize={5}>
                  <LabelList dataKey="requestCount" content={renderCustomizedLabel} />
                </Bar>
              </BarChart>
            </ResponsiveContainer>
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default MonthlyServiceableRequestComponent;
